export const editor = {
  head: "Onelink Config",
  head_text: "(Update download links, etc)",

  heading_download_links: "Add your app download links",
  heading_fallback_link: "Add a fallback link",
  heading_other_settings: "Other settings",

  label_name:
    "Give your onelink a <strong>name</strong>. This is only visible to you.",
  label_customId: "Customize your <strong>onelink.to</strong> URL",
  label_customId_disabled:
    "Customize your <strong>onelink.to</strong> URL. Not in available in Free plan.",

  label_iphone: "URL to your app on <strong>AppStore (iOS)</strong>",
  label_ipad:
    "URL to your <strong>iPad</strong> only version on <strong>AppStore</strong> (iOS)",
  label_android:
    "URL to your app for <strong>Android</strong>, e.g. <strong>Google Play</strong>",
  label_huawei:
    "URL to for <strong>non-Google Huawei</strong>, e.g. <strong>AppGallery</strong>",
  label_blackberry:
    "URL for Blackberry on <strong>Blackberry Appworld</strong> or <strong>Amazon Appstore</strong>",
  label_windows:
    "URL to your app for <strong>Windows Mobile</strong> on Microsoft Store",
  label_kindle:
    "URL to your app for <strong>Fire OS</strong> on <strong>Amazon Appstore</strong>",
  label_fallback: "<strong>Fallback URL</strong> for any other device/browser",

  help_name:
    "Give your link a descriptive name to make it easier to distinguish it from your other onelinks.\n\nThe name is used on the onelink.to site only and only visible to you.",
  help_customId:
    "Use a custom text for your link.\n\nE.g. https://onelink.to/mylink",
  help_customId_disabled:
    "Use a custom text for your link\n\nE.g. https://onelink.to/mylink\n\nThis feature is not available in the Free plan, please upgrade.",
  help_iphone: "Add your app's download link for Apple AppStore or Testflight",
  help_ipad:
    "If you have a specific app version for iPad, add that download link here.\n\nLinks to Apple AppStore or Testflight are accepted.",
  help_android:
    "Add your download link for standard Android devices.\n\nWe accept links to Google Play, Huawei AppGallery, Tencent App Store, Qihoo 360 App Store, Xiomi MIUI App Store, Baido App Store",
  help_huawei:
    "Add a separate download link for Huawei Android devices without Google Play.\n\nMost Huawei Android devices released late 2019 and later do not have access to Google Mobile Services (e.g. Google Play).\n\nWe accept links to Huawei AppGallery, Tencent App Store, Qihoo 360 App Store, Xiomi MIUI App Store, Baido App Store",
  help_blackberry:
    "Add the download link to your app for Blackberry on Blackberry World or Amazon Appstore.\n\nLegacy support for Blackberry OS. All Blackberry devices released since 2015 have Android and Google Play support.",
  help_windows:
    "Add the download link to your app for Windows Mobile on Microsoft Store.\n\nLegacy support for Windows Mobile. Microsoft do not support Windows 10 Mobile since January 2020.",
  help_kindle: "Add URL to your app for Fire OS (Kindle) on Amazon Appstore.",
  help_fallback:
    "Add a fallback URL where we send all devices (browsers) that do not have a download link.",

  url_error: "URL (link) is not accepted",
  custom_id_error: "Custom link already taken",
  custom_id_min_length_template: "Custom path must be at least %s characters",

  label_parameter_forwarding: "Enable parameter forwarding",
  help_parameter_forwarding:
    "Enable parameter forwarding to have URL parameters (query string parameters) forwarded with the redirect.\n\n E.g. https://onelink.to/mylink?campaign=facebook will result in campaign=facebook being added to the redirect link (e.g. AppStore or Google Play)",

  bottom_info:
    "Changes in your configuration can take up to 15 minutes to be updated on all servers",
};
